import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { MosaicoItemComponent } from '../mosaico-item/mosaico-item.component';

@Component({
  selector: 'unh-mosaico-projetos',
  templateUrl: './mosaico-projetos.component.html',
  styleUrls: ['./mosaico-projetos.component.scss']
})
export class MosaicoProjetosComponent {
  @Input() mozaicItems: any[] = [{ 'postloading': true }];

  @ContentChild('mozaicItemTemplate', { static: false })
  mozaicItemTemplateRef: TemplateRef<MosaicoItemComponent>;

  trackByFn (index, item) {
    return index;
  }

  onView() {
    // Not implemented
  }
}
